import { windowPopup } from '../SharingWidget'
import fetch from 'isomorphic-unfetch'

const connectUri = '/twitter/connect'
const statusUri = '/api/profile/twitter_status'

class TwitterLogin {
  constructor() {
    this.popupWindow = null
    this.interval = null
  }

  setupListeners() {
    this.connectButton = document.querySelector('.btn-twitter-connect')

    if (!this.connectButton) return

    this.connectButton.addEventListener('click', event =>
      this.onLoginClick(event)
    )
  }

  onLoginClick(event) {
    this.connectButton.classList.add('loading', 'disabled')

    this.connect()
      .then(response => this.onSuccess(response))
      .catch(() => this.onFail())

    event.preventDefault()
  }

  connect(successCallback, failCallback) {
    const connectPromise = new Promise((resolve, reject) => {
      clearInterval(this.interval)

      this.popupWindow = windowPopup(connectUri, 800, 600)

      this.interval = setInterval(async () => {
        if (this.popupWindow?.closed) {
          clearInterval(this.interval)
          try {
            const res = await fetch(statusUri)
            const resJson = await res.json()
            return resolve(resJson)
          } catch (e) {
            return reject(e)
          }
        }
      }, 1000)
    })

    if (successCallback && failCallback) {
      connectPromise.then(successCallback).catch(failCallback)
    } else {
      return connectPromise
    }
  }

  onSuccess(response) {
    if (response.connected) {
      return window.location.reload()
    }

    this.connectButton.classList.remove('loading', 'disabled')
  }

  onFail() {
    this.connectButton.classList.remove('loading', 'disabled')
  }
}

const twitterLogin = new TwitterLogin()

export default twitterLogin
